<p-panel>
    <div class="container-fluid gap-5">
        <header>
            <h4>Fertirrigación

                <div *ngIf="loadingData" style="
                    display: inline-block;
                    margin-right: 10px;
                    position: relative;
                    top: 3px;">
                    <p-progressSpinner [style]="{width: '20px', height: '20px'}" strokeWidth="6"
                        animationDuration="1.5s">
                    </p-progressSpinner>
                </div>
            </h4>
        </header>
        <div class="row">
            <div class="col">
                <app-reactive-form-builder (formChanges)="formChanges($event[0], $event[1])" (goBack)="goBack()"
                    [form]="form.formFields" [serverUrl]="form.env.auxServerUrl"
                    [dropdownLoadTrigger]="dropdownLoadTrigger" [previousData]="getModel()"
                    [request]="this.getType() === 1 ? this.tareasApi.fertirrigacion.PUT : this.tareasApi.fertirrigacion.POST"
                    [getRequest]="this.tareasApi.fertirrigacion.GET">
                </app-reactive-form-builder>
            </div>
        </div>
    </div>
</p-panel>

<p-dialog
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <form [formGroup]="comunidadForm" class="p-fluid" (ngSubmit)="saveNewOption()">

    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </form>
    <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="this.form.openDialog=false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>

